import ApiUrls from "../ApiUrl";
import BaseService from "../Base";

export default class PaymentServicesV2 extends BaseService {
  async getSubscriptionPlanLists(params: any) {
    try {
      const response = await this.post(
        `${ApiUrls.subscriptionPlanListUrl}/list`,
        params
      );
      return response; // return full response
    } catch (error) {
      throw error;
    }
  }
  async createSubscriptionPlan(params: any) {
    try {
      const response = await this.post(
        `${ApiUrls.subscriptionPlanListUrl}/create`,
        params
      );
      return response; // return full response
    } catch (error) {
      throw error;
    }
  }
  async updateSubscriptionPlan(params: any) {
    try {
      const response = await this.post(
        `${ApiUrls.subscriptionPlanListUrl}/update`,
        params
      );
      return response; // return full response
    } catch (error) {
      throw error;
    }
  }
  async deleteSubsriptionPlans(params: any) {
    try {
      const response = await this.post(
        `${ApiUrls.subscriptionPlanListUrl}/delete`,
        params
      );
      return response; // return full response
    } catch (error) {
      throw error;
    }
  }
  async getFeaturePlanList(params: any) {
    try {
      const response = await this.post(
        `${ApiUrls.planFeatures}/list`,
        params
      );
      return response.data; // return full response
    } catch (error) {
      throw error;
    }
  }
  async createFeaturePlan(params: any) {
    try {
      const response = await this.post(
        `${ApiUrls.planFeatures}/create`,
        params
      );
      return response.data; // return full response
    } catch (error) {
      throw error;
    }
  }
  async updateFeaturePlan(params: any) {
    try {
      const response = await this.post(
        `${ApiUrls.planFeatures}/update`,
        params
      );
      return response.data; // return full response
    } catch (error) {
      throw error;
    }
  }
  async deleteFeaturePlan(params: any) {
    try {
      const response = await this.post(
        `${ApiUrls.planFeatures}/delete`,
        params
      );
      return response.data; // return full response
    } catch (error) {
      throw error;
    }
  }

  
  async createManageSubscriptionFeaturePlan(params: any) {
    try {
      const response = await this.post(
        `${ApiUrls.manageSubscriptionFeatures}/create`,
        params
      );
      return response.data; // return full response
    } catch (error) {
      throw error;
    }
  }
  async updateManageSubscriptionFeaturePlan(params: any) {
    try {
      const response = await this.post(
        `${ApiUrls.manageSubscriptionFeatures}/update`,
        params
      );
      return response.data; // return full response
    } catch (error) {
      throw error;
    }
  }
  async deleteManageSubscriptionFeaturePlan(params: any) {
    try {
      const response = await this.post(
        `${ApiUrls.manageSubscriptionFeatures}/delete`,
        params
      );
      return response.data; // return full response
    } catch (error) {
      throw error;
    }
  }

  async cancelUserSubscription(params: any) {
    try {
      const response = await this.post(
        `${ApiUrls.user}/cancelSubscription`,
        params
      );
      return response.data; // return full response
    } catch (error) {
      throw error;
    }
  }


  
  async getCoinTransaction(params: any) {
    try {
      const response = await this.post(
        `${ApiUrls.coinsTransaction}/list`,
        params
      );
      return response?.data;
    } catch (error) {
      throw error;
    }
  }
  async getCoinsTransactionHistory(params: any) {
    try {
      const response = await this.post(
        `${ApiUrls.coinsTransactionHistory}`,
        params
      );
      return response?.data;
    } catch (error) {
      throw error;
    }
  }
  async getGiancosPackages(params: any) {
    try {
      const response = await this.post(
        `${ApiUrls.giancosPackages}/list`,
        params
      );
      return response?.data;
    } catch (error) {
      throw error;
    }
  }
}
